import { render } from "./Fitxa.vue?vue&type=template&id=6101fc8c&scoped=true"
import script from "./Fitxa.vue?vue&type=script&lang=js"
export * from "./Fitxa.vue?vue&type=script&lang=js"

import "./Fitxa.vue?vue&type=style&index=0&id=6101fc8c&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6101fc8c"]])

export default __exports__